/*
  Păstrează filtrele active DOAR când schimbi subcategoria, nu și când
  schimbi categoria principală.

  Problemă: linkurile din bara de subcategorii (aperte-subcat-bar.liquid) și
  din dropdown-ul de categorii din header (aperte-cat-nav.liquid) sunt randate
  în Liquid, deci nu știu nimic despre filtrele alese de vizitator în pagină
  (acelea trăiesc doar în query string-ul din browser, ex. ?filter.v.option.culoare=Auriu).
  Rezultatul: click pe o subcategorie (ex. Penduluri) duce la colecția nouă
  fără niciun filtru, chiar dacă utilizatorul avea deja o selecție făcută.

  Soluție: după ce pagina s-a încărcat, luăm query string-ul curent (fără
  "page", care nu are sens pe o colecție nouă) și îl adăugăm DOAR la linkurile
  marcate explicit cu atributul data-aperte-subcat — adică exact linkurile
  de subcategorie (surori, în bara de pe pagina de colecție, sau în dropdown-ul
  din header). Linkurile de categorie principală (.aperte-cat-item) și "Toate
  din X" NU sunt marcate, deci nu primesc filtrele — click pe ele duce la
  categoria nouă curată, fără filtre reziduale.

  Shopify ignoră automat filtrele care nu există pentru colecția țintă, deci
  e sigur să trimitem toate filtrele mai departe chiar dacă subcategoria nouă
  nu are exact aceleași opțiuni.
*/
(function () {
  function currentFilterQueryString() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    return params.toString();
  }

  function preserveFilters(selector) {
    var qs = currentFilterQueryString();
    if (!qs) return;

    document.querySelectorAll(selector).forEach(function (link) {
      if (!link.getAttribute('href')) return;
      // Nu suprascrie un link care deja are query string propriu
      if (link.href.indexOf('?') !== -1) return;
      link.href = link.href + '?' + qs;
    });
  }

  function boot() {
    preserveFilters('[data-aperte-subcat]');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
